import { render, staticRenderFns } from "./ModalClearCart.vue?vue&type=template&id=56675466"
import script from "./ModalClearCart.vue?vue&type=script&lang=js"
export * from "./ModalClearCart.vue?vue&type=script&lang=js"
import style0 from "./ModalClearCart.vue?vue&type=style&index=0&id=56675466&prod&module=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports